import Client from "../client";

export class Bookmark {
  static async list(currentPage: number, order: string) {
    return await Client.get<any[]>(`/bookmark/${order}`, { currentPage });
  }
}
